<template>
  <div class="form text-left">
    <div class="container">
      <div class="d-flex mb-10 no-print">
        <button @click="$router.push('requestList')" class="app-btn px-3">
          <v-icon class="mr-3 white-icon" name="arrow-left" scale="1.5"/> Atrás
        </button>&nbsp;
        <button @click="imprimir()" class="btn btn-secondary px-3">
          <v-icon class="mr-3 white-icon" name="print" scale="1.5"/> Imprimir
        </button>
      </div>
    

    <div id="informationPrint">

      <div class="d-flex justify-content-between">
        <span>
          <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
          Fecha de solicitud: {{requestDetail.createdDate | formatDate}}
        </span>
        <div class="d-flex">
            <div class="application-number mr-2">
              Solicitud - <span v-if="requestDetail.conectionType == 'Simple'">UPB</span> <span v-if="requestDetail.conectionType == 'Compleja'">UPM</span>
            </div>
            <div class="application-number">
              #{{requestDetail.id}}
            </div>
        </div>
      </div>
      <h2 class="text-center mb-3">Etapa actual de la solicitud</h2>
      <div class="steps-wrap mb-5">
        
        <div class="step done">
          <span>Solicitud de servicio</span>
        </div>
        
        <div class="step"
          :class="{
            'active':requestDetail.stage == 'factibilidad-servicio',
            'done':requestDetail.stage == 'aprobacion-disenos' || requestDetail.stage == 'ejecucion-obras' || requestDetail.stage == 'puesta-en-servicio' || requestDetail.stage == 'pendiente-disenos'|| requestDetail.stage == 'pendiente-solicitud-supervision' || requestDetail.stage == 'pendiente-asignacion-supervision'
          }">
          <span>Factibilidad del Servicio</span>
        </div>
        
        <div class="step"
          :class="{
            'active':requestDetail.stage == 'pendiente-disenos',
            'done':requestDetail.stage == 'aprobacion-disenos' || requestDetail.stage == 'ejecucion-obras' || requestDetail.stage == 'puesta-en-servicio'|| requestDetail.stage=='factibilidad-servicio' || requestDetail.stage == 'pendiente-solicitud-supervision'  || requestDetail.stage == 'pendiente-asignacion-supervision'
          }">
          <span>Pendiente de envío de diseños</span>
        </div>

        <div class="step"
          :class="{
            'active':requestDetail.stage == 'aprobacion-disenos',
            'done':requestDetail.stage == 'ejecucion-obras' || requestDetail.stage == 'puesta-en-servicio'|| requestDetail.stage == 'pendiente-solicitud-supervision'  || requestDetail.stage == 'pendiente-asignacion-supervision'
          }">
          <span>Revisión y Aprobación Diseños</span>
        </div>
        
        <div class="step"
          :class="{
            'active':requestDetail.stage == 'pendiente-solicitud-supervision',
            'done':requestDetail.stage == 'ejecucion-obras' ||  requestDetail.stage == 'puesta-en-servicio'  || requestDetail.stage == 'pendiente-asignacion-supervision'
          }">
          <span>Pendiente de solicitud de supervisión</span>
        </div>

        <div class="step"
          :class="{
            'active':requestDetail.stage == 'pendiente-asignacion-supervision', 
            'done':requestDetail.stage == 'ejecucion-obras' || requestDetail.stage == 'puesta-en-servicio'
          }">
          <span>Asignación de supervisión</span>
        </div>

        <div class="step"
          :class="{
            'active':requestDetail.stage == 'ejecucion-obras', 
            'done':requestDetail.stage == 'puesta-en-servicio'
          }">
          <span>Ejecución de Obras</span>
        </div>
        <div class="step" :class="{
            'active':requestDetail.stage == 'puesta-en-servicio' && requestDetail.status != 'finalizado',
            'done':requestDetail.stage == 'puesta-en-servicio' && requestDetail.status == 'finalizado'
          }">
          <span>Puesta en servicio</span>
        </div>
      </div>
      
      <div v-if="requestDetail.stage == 'pendiente-disenos' && requestDetail.status != 'anulado' && requestDetail.status != 'finalizado'" class="actions d-flex justify-content-center mb-5">
        <button class="app-btn app-btn--green px-4" @click="$router.push('designDataForm')">
          Subir información del diseño y/o pagos <v-icon class="ml-3 white-icon" name="file-upload" scale="1.5"/>
        </button>
      </div>

      <div v-if="requestDetail.stage == 'aprobacion-disenos' && requestDetail.status != 'anulado' && requestDetail.status != 'finalizado'" class="actions d-flex justify-content-center mb-5">
        <button class="app-btn app-btn--green px-4" @click="$router.push('liquidationPayment')">
          Pago de liquidación <v-icon class="ml-3 white-icon" name="file-upload" scale="1.5"/>
        </button>
      </div>

      <div v-if="requestDetail.stage == 'pendiente-solicitud-supervision' && requestDetail.status != 'anulado'" class="actions d-flex justify-content-center mb-5">
        <button class="app-btn app-btn--blue px-4 mr-3" @click="$router.push('supervisionRequest')">
          Solicitar Supervisión de Obra <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
        </button> 
      </div>

      <div v-if="requestDetail.stage == 'ejecucion-obras' && requestDetail.status != 'anulado'" class="actions d-flex justify-content-center mb-5">
        <button class="app-btn app-btn--blue px-4 mr-3" @click="$router.push('monitoringActivity')">
          Notificaciónes y/o Carga de Documentos <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
        </button>
      </div>
      <div v-if="requestDetail.stage == 'puesta-en-servicio' && requestDetail.status != 'finalizado' && requestDetail.status != 'anulado'" class="actions d-flex justify-content-center mb-5">
        <button class="app-btn app-btn--green px-4 mr-3" @click="$router.push('putInServiceActivity')">
          Agregar actividad de puesta en servicio <v-icon class="ml-3 white-icon" name="hammer" scale="1.5"/>
        </button>
      </div>
      <div v-if="requestDetail.status == 'finalizado'" class="alert alert-success no-print" role="alert">
          El proceso de la solicitud de servicio ha finalizado.
      </div>
      <div v-if="requestDetail.stage == 'factibilidad-servicio' && !refuseConnection && requestDetail.status != 'anulado'" class="alert alert-info no-print" role="alert">
          Emcali está revisando tu solicitud y evaluando la factibilidad del servicio
      </div>
      <div v-if="refuseConnection" class="alert alert-danger no-print" role="alert">
          Su conexión ha sido rechazada. Si lo desea, puede volver a iniciar una nueva solicitud haciendo click <router-link to="/form">aquí</router-link>
      </div>


      <div class="infoTab mb-4">
        <div class="infoTab--header" @click="showServiceDetail = !showServiceDetail">
          <span>Detalle del servicio</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showServiceDetail}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showServiceDetail == true">
          <p><b>Nombre del proyecto:</b> {{requestDetail.proyectName}}</p>
          <p><b>Servicio solicitado:</b> {{requestDetail.serviceDetail.requestedService.description}}</p>
          <div v-if="requestDetail.serviceDetail.requestedService.conectionType == 'Simple'">
            <p><b>Carga kW Requerida: {{requestDetail.serviceDetail.chargeRequired}}</b></p>
            <p><b>Carga kW Existente: {{requestDetail.serviceDetail.chargeExistent}}</b></p>
            <p><b>Incluye sistema de autogeneración: {{requestDetail.serviceDetail.generationSistem == 1 ? 'Si':'No'}}</b></p>
          </div>
          <div v-if="requestDetail.serviceDetail.requestedService.conectionType == 'Compleja'">
            <div v-if="requestDetail.serviceDetail.requestedService.id == '10'">
              <p><b>Matrícula inmobiliaria:</b> {{requestDetail.serviceDetail.realStateRegistration}}</p>
              <p><b>Número del predial:</b> {{requestDetail.serviceDetail.areaMt2}}</p>
              <p><b>Número de usuarios:</b> {{requestDetail.serviceDetail.numbeUsers}}</p>
              <p><b>Nodo de referencia:</b> {{requestDetail.serviceDetail.nodoReference}}</p>
              <p><b>Capacidad en kVA Solicitada:</b> {{requestDetail.serviceDetail.capacityKvaSolicited}}</p>
            </div>
            <div v-if="requestDetail.serviceDetail.requestedService.id == '9'">
              <p><b>Matrícula inmobiliaria: {{requestDetail.serviceDetail.realStateRegistration}}</b></p>
              <p><b>Número del predial:</b> {{requestDetail.serviceDetail.areaMt2}}</p>
              <p><b>Número de usuarios:</b> {{requestDetail.serviceDetail.numbeUsers}}</p>
              <p><b>Nodo de referencia:</b> {{requestDetail.serviceDetail.nodoReference}}</p>
            </div>
            <div v-if="requestDetail.serviceDetail.requestedService.id == '8'">

              <p><b>Tipo de proyecto:  </b>
                {{requestDetail.serviceDetail.basicDataConexionPoint == '1' ? 'Proyecto Nuevo':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '2' ? 'Aumento de capacidad':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '3' ? 'Provisional de obra':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '4' ? 'Modificación de datos básicos':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '5' ? 'Cambio de nivel de tensión en el punto de conexión':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '6' ? 'Cambio de nivel de tensión en la medida':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '7' ? 'Reubicación de redes':''}} 
                {{requestDetail.serviceDetail.basicDataConexionPoint == '8' ? 'Alumbrado público con montaje de transformador':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '9' ? 'Alumbrado Público para adicionar a transformador existente':''}}
                {{requestDetail.serviceDetail.basicDataConexionPoint == '10' ? 'Disminución de carga':''}}
              
              </p>

              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '1'">
                <p><b>Número de usuarios:</b> {{requestDetail.serviceDetail.numbeUsers}}</p>
                <p><b>Capacidad del transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformerInstall}}</p>
                <p><b>Tipo de subestación a instalar:</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Vigencia:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4" @click="tipoCarga = true; tipoCargaRecord()">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '2'">
                <p><b>Número de contrato:</b> {{requestDetail.serviceDetail.contractNumber}}</p>
                <p><b>Número de transformador actual:</b> {{requestDetail.serviceDetail.transformerNumber}}</p>
                <p><b>Nodo:</b> {{requestDetail.serviceDetail.nodo}}</p>
                <p><b>Capacidad de transformador actual (kVA):</b> {{requestDetail.serviceDetail.capacityTransformer}}</p>
                <p><b>Se retira transformador:</b> {{requestDetail.serviceDetail.transformerRecall == '1' ? 'Si':'No'}}</p>
                <p><b>Tipo de subestación a instalar (kVA):</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Capacidad del transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformerInstall}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '3'">
                <p><b>Capacidad del transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformerInstall}}</p>
                <p><b>Tipo de subestación:</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Nodo de referencia:</b> {{requestDetail.serviceDetail.nodoReference}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '4'">
                <p><b>Número de documento a modificar:</b> {{requestDetail.serviceDetail.documentModify}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '5'">
                <p><b>Número de transformador actual:</b> {{requestDetail.serviceDetail.transformerNumber}}</p>
                <p><b>Nivel de tensión requerido: {{requestDetail.serviceDetail.kvRequiered.description}}</b></p>
                <p><b>Nodo:</b> {{requestDetail.serviceDetail.nodo}}</p>
                <p><b>Capacidad de transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformer}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '6'">
                <p><b>Número de transformador actual:</b> {{requestDetail.serviceDetail.transformerNumber}}</p>
                <p><b>Nodo:</b> {{requestDetail.serviceDetail.nodo}}</p>
                <p><b>Capacidad de transformador actual (kVA):</b> {{requestDetail.serviceDetail.capacityTransformer}}</p>
                <p><b>Tipo de subestación a instalar (kVA):</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '7'">
                <p><b>Nodo referencia 1:</b> {{requestDetail.serviceDetail.nodoReference1}}</p>
                <p><b>Nodo referencia 2:</b> {{requestDetail.serviceDetail.nodoReference2}}</p>
                <p><b>Tramo de la red a intervenir:</b> {{requestDetail.serviceDetail.sectionNetwork}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '8'">
                <p><b>Capacidad del transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformerInstall}}</p>
                <p><b>Número de luminarias:</b> {{requestDetail.serviceDetail.numbeUsers}}</p>
                <p><b>Tipo de subestación a instalar:</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '9'">
                <p><b>Capacidad del transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformerInstall}}</p>
                <p><b>Número de luminarias:</b> {{requestDetail.serviceDetail.numbeUsers}}</p>
                <p><b>Tipo de subestación existente:</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
              <div v-if="requestDetail.serviceDetail.basicDataConexionPoint == '10'">
                <p><b>Número de contrato:</b> {{requestDetail.serviceDetail.contractNumber}}</p>
                <p><b>Número de transformador actual:</b> {{requestDetail.serviceDetail.transformerNumber}}</p>
                <p><b>Nodo:</b> {{requestDetail.serviceDetail.nodo}}</p>
                <p><b>Capacidad de transformador actual (kVA):</b> {{requestDetail.serviceDetail.capacityTransformer}}</p>
                <p><b>Se retira transformador:</b> {{requestDetail.serviceDetail.transformerRecall == '1' ? 'Si':'No'}}</p>
                <p><b>Tipo de subestación a instalar (kVA):</b> {{requestDetail.serviceDetail.substationType}}</p>
                <p><b>Capacidad del transformador a instalar (kVA):</b> {{requestDetail.serviceDetail.capacityTransformerInstall}}</p>
                <p><b>Nivel de tensión: </b> {{requestDetail.serviceDetail.tensionRequested == 1 ? 'Nivel 1. Tensión menor a 1 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 2 ? 'Nivel 2. Tensión mayor o igual a 1 kV y menor a 30 kV':''}}
                 {{requestDetail.serviceDetail.tensionRequested == 3 ? 'Nivel 3. Tensión mayor o igual a 30 kV y menor a 57.5 kV':''}}</p>
                 <p><b>Fecha estimada de operación:</b> {{requestDetail.fechaOperacion}}</p>
                 <button class="app-btn app-btn--blue px-4">
                  Tipo de carga <v-icon class="ml-3 white-icon" name="eye" scale="1.5"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>




      <div class="infoTab mb-4" v-for="(item, index) in sortedItems" :key="index"
        :class="{
          'infoTab--green': item.state == 'Approved',
          'infoTab--red': item.state == 'Refuse'  || item.state == 'Cancel',
          'infoTab--blue no-print': item.state == 'Other',
          
        }">
        <div class="infoTab--header">
          <span v-if="item.titleHeader == 'Liquidación de diseños' && item.type == 'voucher'">Comprobante de pago</span>
          <span v-else-if="item.titleHeader == 'Diseños Devueltos'">{{item.titleHeader}} (Revisión {{item.increment}})</span>
          <span v-else>
            <span>{{item.titleHeader}}</span>
          </span>
          <span>{{item.createDate | formatDate}}</span>
        </div>

        <div v-if="item.titleHeader == 'Solicitud Anulada'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p style="white-space: pre-line;"><b>Motivo de rechazo:</b> {{item.comments}}</p>
          <div class="d-flex">
            <div v-for="doc in item.documents" :key="doc.id" class="document mr-2 mb-2">
              <a :download="doc.description" :href="doc.anexo">
                {{doc.description}} <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>
        </div>

        <div v-if="item.titleHeader == 'Conexión Rechazada'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p style="white-space: pre-line;"><b>Motivo de rechazo:</b> {{item.comments}}</p>
          <div class="d-flex">
            <div v-for="doc in item.documents" :key="doc.id" class="document mr-2 mb-2">
              <a :download="doc.description" :href="doc.anexo">
                {{doc.description}} <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>
        </div>
        <div v-if="item.titleHeader == 'Conexión Aprobada'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p><b>Vigencia en meses:</b> 12</p>
          <p><b>Vigencia del proyecto:</b> {{item.vigencia | formatDate}}</p>
          <p v-if="item.chageApproved"><b>Capacidad aprobada (kVA):</b> {{item.chageApproved}}</p>
          <p v-if="item.tensionNetwork"><b>Redes en media tensión:</b>
            <span v-if="item.tensionNetwork == 1"> Aérea</span>
            <span v-if="item.tensionNetwork == 2"> Subterránea</span>
          </p>
          <p v-if="item.idKvRequieredApproved"><b>Nivel de tensión aprobado para el punto de conexión:</b>
            <span v-if="item.idKvRequieredApproved == 1"> Nivel 1. Tensión menor a 1 kV</span>
            <span v-if="item.idKvRequieredApproved == 2"> Tensión mayor o igual a 1 kV y menor a 30 kV</span>
            <span v-if="item.idKvRequieredApproved == 3"> Tensión mayor o igual a 30 kV y menor a 57.5 kV</span>
          </p>
          <p v-if="item.connectionTypeS"><b>Acometida en Media Tensión:</b>
            <span v-if="item.connectionTypeS == 3"> Aérea</span>
            <span v-if="item.connectionTypeS == 4"> Subterránea</span>
          </p>
          <p v-if="item.connectionTypeA"><b>Acometida en Baja Tensión:</b>
            <span v-if="item.connectionTypeA == 1"> Aérea</span>
            <span v-if="item.connectionTypeA == 2"> Subterránea</span>
          </p>
          <p v-if="item.connectionTypeP"><b>Tipo de Subestación a montar:</b>
            <span v-if="item.connectionTypeP == 5"> Interior</span>
            <span v-if="item.connectionTypeP == 6"> Exterior</span>
            <span v-if="item.connectionTypeP == 7"> Exterior - Interior</span>
          </p>
          <p v-if="item.nodoReference"><b>Nodo de referencia:</b> {{item.nodoReference}}</p>
          <p v-if="item.transformerNumber"><b>No. transformador:</b> {{item.transformerNumber}}</p>
          <p v-if="item.kvaTransformerDistribution"><b>kVA Transformador de Distribución:</b> {{item.kvaTransformerDistribution}}</p>
          <p v-if="item.circutName"><b>Nombre del circuito:</b> {{item.circutName}}</p>
          <p v-if="item.circutNameMt"><b>Nombre de circuito:</b> {{item.circutNameMt}}</p>
          <p v-if="item.subestationPower"><b>Nombre Subestación de Potencia:</b> {{item.subestationPower}}</p>
          <p v-if="item.subestationDistance"><b>Distancia a la Subestación (m):</b> {{item.subestationDistance}}</p>
          <p v-if="item.ciurcuitLevel30"><b>Nivel de cortocircuito 3Ø (kA):</b> {{item.ciurcuitLevel30}}</p>
          <p v-if="item.ciurcuitLevel10"><b>Nivel de cortocircuito 1Ø (kA):</b> {{item.ciurcuitLevel10}}</p>
          <p v-if="item.impedance"><b>Impedancia (x):</b> {{item.impedance}}</p>
          <p v-if="item.redactance"><b>Reactancia (R):</b> {{item.redactance}}</p>
          <p v-if="item.nodo"><b>Nodo:</b> {{item.nodo}}</p>
          <p style="white-space: pre-line;"><b>Comentarios de aprobación:</b> {{item.comments}}</p>

          <div class="d-flex">
            <div v-for="doc in item.documents" :key="doc.id" class="document mr-2 mb-2">
              <a :download="doc.description" :href="doc.anexo">
                {{doc.description}} <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>

          <div v-if="requestDetail.serviceDetail.requestedService.conectionType == 'Compleja'">

            <hr class="my-3">

            <h5>OBSERVACIONES:</h5>
            <p style="white-space: pre-line;">
              {{observationComment}}
            </p>
          </div>

        </div>
        <div v-if="item.titleHeader == 'Información de diseño'" class="infoTab--body">
          <div  class="row">
            <div class="col col-md-6">              
              <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
              <p><b>Nombre o razón social:</b> {{item.nameRazon}}</p>
              <p><b>Tipo de documento:</b> {{item.documentType}}</p>
              <p><b>Nombre del ingeniero / diseñador:</b> {{item.ingName}}</p>
              <p><b>Número de documento:</b> {{item.documentNumber}}</p>
              <p><b>Matrícula profesional:</b> {{item.profesionalEnrollment}}</p>
            </div>
            <div class="col col-md-6">  
              <p><b>Celular:</b> {{item.celPhoneNumber}}</p>
              <p><b>Correo:</b> {{item.email}}</p>
              <p v-if="item.address != null"><b>Dirección:</b> {{item.address.streetType == null ? '' : item.address.streetType}} {{item.address.road1}}{{item.address.road1Direction == 'Ninguna' ? '':item.address.road1Direction}} # {{item.address.road2}}{{item.address.road2Direction == 'Ninguna' ? '':item.address.road2Direction}} - {{item.address.streetNumber}}</p>
              <p><b>Descripción:</b> {{item.address.description}}</p>
              <p><b>Municipio:</b> {{item.municipality}}</p>
            </div>

            <div class="col col-md-6">  
              <p><b>Documento que se presenta para revisión:</b> {{item.docRevision}}</p>
              <p><b>Nombre constructora:</b> {{item.nombreConstructura}}</p>
              <p><b>Nombre representante legal:</b> {{item.nombreRepreLegal}}</p>
              <p><b>Teléfono contacto:</b> {{item.celPhoneRepreLegal}}</p>
            </div>
            <div class="col col-md-6"> 
              <p>&nbsp;</p>
              <p><b>NIT:</b> {{item.nitConstructura}}</p>
              <p><b>Cédula representante legal:</b> {{item.documentRepreLegal}}</p>
              <p><b>Correo electrónico:</b> {{item.emailRepreLegal}}</p>
            </div>
          </div>

          <div class="row">
            <div v-for="doc in item.documents" :key="doc.id" class="document col-md-6">
              <a :download="doc.description" :href="doc.anexo">
                <strong>{{doc.desingDocumentItem.id}}. {{doc.desingDocumentItem.name}}</strong> - {{doc.description}} <v-icon class="ml-1" name="download" scale="1.5"/>
              </a>
            </div>
          </div>

          <hr class="my-3">
          <h5>OBSERVACIONES:</h5>
          <p style="white-space: pre-line;">
            {{item.observaciones}}
          </p>
        </div>
        <div v-if="item.titleHeader == 'Diseños Devueltos'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p style="white-space: pre-line;"><b>Motivo devolución:</b> {{item.comments}}</p>
          <div>
            <div v-for="doc in item.documents" :key="doc.id" class="document mr-2 mb-2">
              <a :download="doc.description" :href="doc.anexo">
                {{doc.description}} <v-icon class="ml-1" name="download" scale="1.5"/>
              </a>
            </div>
          </div>
        </div>
        <div v-if="item.titleHeader == 'Liquidación de diseños'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p v-if="item.liquidationDate"><b>Fecha liquidación de pagos a EMCALI en etapa de diseño:</b> {{item.liquidationDate | formatDate}}</p>
          <p v-if="item.designRightsPayDate"><b>Fecha de pago de derechos de revisión del diseño:</b> {{item.designRightsPayDate | formatDate}}</p>
          <div class="d-flex mb-3">
            <div v-if="item.document" class="document">
              <a :download="'liquidation-document-' + item.id + '-' + item.idRequest" :href="item.document">
                <span v-if="item.type == 'voucher'">Descargar comprobante de pago</span>
                <span v-if="item.type == 'liquidation'">Descargue su factura</span> <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>
        </div>
        <div v-if="item.titleHeader == 'Aprobación diseños'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p style="white-space: pre-line;"><b>Comentarios de aprobación:</b> {{item.comments}}</p>
          <div class="d-flex">
            <div v-if="item.document" class="document">
              <a :download="'aprobation-document-' + item.id + '-' + item.idRequest" :href="item.document">
                Documento Anexo <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>
        </div>
        <div v-if="item.titleHeader == 'Actividad de supervisión de obra'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p><b>Nombre de la actividad:</b> {{item.title}}</p>
          <p style="white-space: pre-line;"><b>Descripción:</b> {{item.comments}}</p>
          <p v-if="item.reference" style="white-space: pre-line;"><b>Referencia:</b> {{item.reference}}</p>
          <div class="d-flex">
            <div v-for="doc in item.documents" :key="doc.id" class="document mr-2 mb-2">
              <a :download="doc.description" :href="doc.anexo">
                {{doc.description}} <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>
        </div>
        <div v-if="item.titleHeader == 'Actividad de puesta en servicio'" class="infoTab--body">
          <p><b>Fecha:</b> {{item.createDate | formatDate}}</p>
          <p><b>Nombre de la actividad:</b> {{item.title}}</p>
          <p style="white-space: pre-line;"><b>Descripción:</b> {{item.comments}}</p>
          <div class="d-flex">
            <div v-for="doc in item.documents" :key="doc.id" class="document mr-2 mb-2">
              <a :download="doc.description" :href="doc.anexo">
                {{doc.description}} <v-icon class="ml-1" name="download" scale="1.0"/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="infoTab mb-4 no-print">
        <div class="infoTab--header" @click="showSolicitantInfo = !showSolicitantInfo">
          <span>Datos del solicitante</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showSolicitantInfo}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showSolicitantInfo == true">
          <div class="row">
            <div class="col col-md-6">
              <p><b>Nombre:</b> {{requestDetail.applicantInfo.name}}</p>
              <p><b>Email:</b> {{requestDetail.applicantInfo.email}}</p>
              <p><b>Celular:</b> {{requestDetail.applicantInfo.celphoneNumber}}</p>
              <p><b>Teléfono:</b> {{requestDetail.applicantInfo.phone}}</p>
              <p><b>Departamento:</b> {{requestDetail.applicantInfo.department}}</p>
              <p><b>Comuna:</b> {{requestDetail.applicantInfo.commune}}</p>
              <p><b>Municipio:</b> {{requestDetail.applicantInfo.municipality}}</p>
              <div class="d-flex">
                <div class="document" v-if="requestDetail.applicantInfo.idDocumentCopy != null">
                  <a download="id-document" :href="requestDetail.applicantInfo.idDocumentCopy">
                    Documento de identidad <v-icon class="ml-1" name="download" scale="1.0"/>
                  </a>
                </div>
                <div class="document mr-3" v-if="requestDetail.applicantInfo.documentPointConection != null">
                  <a download="punto-conexion" :href="requestDetail.applicantInfo.documentPointConection">
                    Informacion punto de conexion <v-icon class="ml-1" name="download" scale="1.5"/>
                  </a>
                </div>   
              </div>
              <div class="d-flex mt-3" v-if="requestDetail.applicantInfo.authLetter != null">
                <div class="document">
                  <a download="carta-autorizacion" :href="requestDetail.applicantInfo.authLetter">
                    Carta de autorización <v-icon class="ml-1" name="download" scale="1.0"/>
                  </a>
                </div>
              </div>
            </div>
            <div class="col col-md-6">
              <p><b>Tipo de persona:</b> {{requestDetail.applicantInfo.personType}}</p>
              <p v-if="requestDetail.applicantInfo.personType == 'Juridica'"><b>Tipo de jurídica:</b> {{requestDetail.applicantInfo.juridicType}}</p>
              <p><b>Tipo de documento:</b> {{requestDetail.applicantInfo.documentType}}</p>
              <p><b>Documento:</b> {{requestDetail.applicantInfo.documentNumber}}</p>
              <p v-if="requestDetail.applicantInfo.address != null"><b>Dirección:</b> {{requestDetail.applicantInfo.address.streetType  == null ? '' : requestDetail.applicantInfo.address.streetType}} {{requestDetail.applicantInfo.address.road1}}{{requestDetail.applicantInfo.address.road1Direction == 'Ninguna' ? '':requestDetail.applicantInfo.address.road1Direction}} # {{requestDetail.applicantInfo.address.road2}}{{requestDetail.applicantInfo.address.road2Direction == 'Ninguna' ? '':requestDetail.applicantInfo.address.road2Direction}} - {{requestDetail.applicantInfo.address.streetNumber}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="infoTab mb-4 no-print">
        <div class="infoTab--header" @click="showSubscriptorInfo = !showSubscriptorInfo">
          <span>Datos del suscriptor o usuario (Propietario)</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showSubscriptorInfo}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showSubscriptorInfo == true">
          <div class="row">
            <div class="col col-md-6">
               <p><b>Nombre:</b> {{requestDetail.subscriptorInfo.name}}</p>
               <p><b>Email:</b> {{requestDetail.subscriptorInfo.email}}</p>
               <p><b>Celular:</b> {{requestDetail.subscriptorInfo.celphoneNumber}}</p>
               <p><b>Teléfono:</b> {{requestDetail.subscriptorInfo.phone}}</p>
               <p><b>Departamento:</b> {{requestDetail.subscriptorInfo.department}}</p>
               <p><b>Comuna:</b> {{requestDetail.subscriptorInfo.commune}}</p>
               <p><b>Municipio:</b> {{requestDetail.subscriptorInfo.municipality}}</p>
               <div class="d-flex">
                 <div class="document" v-if="requestDetail.subscriptorInfo.idDocumentCopy != null">
                   <a download="id-document" :href="requestDetail.subscriptorInfo.idDocumentCopy">
                     Documento de identidad <v-icon class="ml-1" name="download" scale="1.0"/>
                   </a>
                 </div>
               </div>
             </div>
             <div class="col col-md-6">
               <p><b>Tipo de persona:</b> {{requestDetail.subscriptorInfo.personType}}</p>
               <p v-if="requestDetail.subscriptorInfo.personType == 'Juridica'"><b>Tipo de jurídica:</b> {{requestDetail.subscriptorInfo.juridicType}}</p>
               <p><b>Tipo de documento:</b> {{requestDetail.subscriptorInfo.documentType}}</p>
               <p><b>Documento:</b> {{requestDetail.subscriptorInfo.documentNumber}}</p>
               <p v-if="requestDetail.subscriptorInfo.address != null"><b>Dirección:</b> {{requestDetail.subscriptorInfo.address.streetType == null ? '' : requestDetail.subscriptorInfo.address.streetType}} {{requestDetail.subscriptorInfo.address.road1}}{{requestDetail.subscriptorInfo.address.road1Direction == 'Ninguna' ? '':requestDetail.subscriptorInfo.address.road1Direction}} # {{requestDetail.subscriptorInfo.address.road2}}{{requestDetail.subscriptorInfo.address.road2Direction == 'Ninguna' ? '':requestDetail.subscriptorInfo.address.road2Direction}} - {{requestDetail.subscriptorInfo.address.streetNumber}}</p>
             </div>           
          </div>
        </div>
      </div>
      <div class="infoTab mb-4 no-print">
        <div class="infoTab--header" @click="showPredioInfo = !showPredioInfo">
          <span>Datos del predio</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showPredioInfo}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showPredioInfo == true">
          <div class="row">
            <div class="col col-md-6">
              <p><b>Zona:</b> {{requestDetail.estateInfo.zoneType}}</p>
              <p><b>Número de predial:</b> {{requestDetail.estateInfo.predioNumber}}</p>
              <p><b>Número de cuenta NIE:</b> {{requestDetail.estateInfo.nieAccountNumber}}</p>
              <div v-if="requestDetail.estateInfo.zoneType == 'Urbana'">
                <p v-if="requestDetail.estateInfo.address != null"><b>Dirección:</b> {{requestDetail.estateInfo.address.streetType == null ? '' : requestDetail.estateInfo.address.streetType}} {{requestDetail.estateInfo.address.road1}}{{requestDetail.estateInfo.address.road1Direction == 'Ninguna' ? '':requestDetail.estateInfo.address.road1Direction}} # {{requestDetail.estateInfo.address.road2}}{{requestDetail.estateInfo.address.road2Direction == 'Ninguna' ? '':requestDetail.estateInfo.address.road2Direction}} - {{requestDetail.estateInfo.address.streetNumber}}</p>
              </div>
              <div v-if="requestDetail.estateInfo.zoneType == 'Rural'">
                <p><b>Latitud (N):</b> {{requestDetail.estateInfo.latitud}}</p>
                <p><b>Longitud (W):</b> {{requestDetail.estateInfo.longitud}}</p>
                <p style="white-space: pre-line;"><b>Indicaciones de acceso:</b> {{requestDetail.estateInfo.indications}}</p>
              </div>
            </div>
            <div class="col col-md-6">
              <p><b>Departamento:</b> {{requestDetail.estateInfo.department}}</p>
              <p v-if="requestDetail.estateInfo.commune <= 22"><b>Comuna:</b> {{requestDetail.estateInfo.commune}}</p>
              <p v-if="requestDetail.estateInfo.commune == 23"><b>Comuna:</b> Yumbo</p>
              <p v-if="requestDetail.estateInfo.commune == 24"><b>Comuna:</b> Jamundí</p>
              <p v-if="requestDetail.estateInfo.commune == 25"><b>Comuna:</b> Pto tejada</p>
              <p><b>Municipio:</b> {{requestDetail.estateInfo.municipality}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="infoTab mb-4 no-print">
        <div class="infoTab--header" @click="showTypeOfUse = !showTypeOfUse">
          <span>Tipo de uso y actividad económica</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showTypeOfUse}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showTypeOfUse == true">
          <div class="row">
            <div class="col col-md-6">
              <p><b>Tipo de uso:</b> {{requestDetail.typesUseEconomicActivity.typeUse}}</p>
              <p v-if="requestDetail.typesUseEconomicActivity.typeUse == 'Residencial'"><b>Tipo de proyecto a realizar:</b> {{requestDetail.typesUseEconomicActivity.residencialType}}</p>
              <p><b>Estrato socioeconómico:</b> {{requestDetail.typesUseEconomicActivity.socioEconomic}}</p>
              <!-- <p><b>Actividad económica:</b> {{requestDetail.typesUseEconomicActivity.economicActivity.description}}</p> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="requestDetail.serviceDetail.basicDataConexionPoint != 2 && requestDetail.serviceDetail.basicDataConexionPoint != 5 && requestDetail.serviceDetail.basicDataConexionPoint != 6" class="infoTab mb-4 no-print">
        <div class="infoTab--header" @click="showInfrastructureData = !showInfrastructureData">
          <span>Datos de infraestructura actual</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showInfrastructureData}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showInfrastructureData == true">
          <p><b>¿Red eléctrica cercana al predio?</b> {{requestDetail.electricInfrastructure.closeElectricRed == 1 ? 'Si':'No'}}</p>
          <p v-if="requestDetail.electricInfrastructure.closeElectricRed"><b>Distancia de la red más cercana (m):</b> {{requestDetail.electricInfrastructure.redDistance}}</p>
          <p v-if="requestDetail.electricInfrastructure.closeElectricRed"><b>Número del nodo más cercano:</b> {{requestDetail.electricInfrastructure.transformerNumber}}</p>
        </div>
      </div>

      <div class="infoTab mb-4 no-print">
        <div class="infoTab--header" @click="showObservations = !showObservations">
          <span>Observaciones del detalle del servicio</span>
          <div>
            <v-icon name="angle-right" :class="{'rotate':showObservations}" scale="1.5"/>
          </div>
        </div>
        <div class="infoTab--body" v-if="showObservations == true">
          <p  style="white-space: pre-line;">{{requestDetail.observactions}}</p>
        </div>
      </div>
    </div>
  </div>
    
    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <div v-if="tipoCarga == false" class="carga-modal">
      <div @click="tipoCargaAccept = false" class="backdrop"></div>
        <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="history" scale="2" class="mr-3"/>
            Tipo de Carga
          </div>
          <div>            
            <div id="listorder">  
              <table class="table table-striped table-bordered table-responsive">
                <thead>
                  <tr>
                    <th scope="col">Tipo de carga</th>
                    <th scope="col">Monofásica</th>
                    <th scope="col">Bifásica</th>
                    <th scope="col">Trifásica</th>                    
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="carga in tipoCargaList" :key="carga.id">
                  <td>
                    {{carga.tipoCarga == 'residencial' ? 'Residencial':''}}
                    {{carga.tipoCarga == 'comercial' ? 'Comercial':''}}
                    {{carga.tipoCarga == 'industial' ? 'Industial':''}}
                    {{carga.tipoCarga == 'oficial' ? 'Oficial':''}}
                    {{carga.tipoCarga == 'oficial' ? 'Oficial':''}}
                    {{carga.tipoCarga == 'alumbradoPublico' ? 'Alumbrado Publico':''}}
                    {{carga.tipoCarga == 'provisionalObra' ? 'Provisional de Obra':''}}
                    {{carga.tipoCarga == 'otro' ? 'Otro':''}}
                    {{carga.tipoCarga == 'totalPorCarga' ? 'Total por clase de carga':''}}
                    {{carga.tipoCarga == 'totalCargas' ? 'Número  total de cuentas':''}}
                  </td>
                  <td>{{carga.monofasica}}</td>
                  <td>{{carga.bifasica}}</td>
                  <td>{{carga.trifasica}}</td>
                  <td>{{carga.totalCargas}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3 " style="padding-top: 20px;">
            <button @click="tipoCargaAccept = false; tipoCarga = true" class="app-btn app-btn">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import axios from "axios";

export default {
  data(){
    return {
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      showSolicitantInfo: true,
      showSubscriptorInfo: true,
      showPredioInfo: true,
      showTypeOfUse: true,
      showInfrastructureData: true,
      showServiceDetail: true,
      showObservations: true,
      showDocuments: false,
      requestHistory: [],
      tipoCargaList: [],
      tipoCarga: true,
      tipoCargaAccept: false,
      refuseConnection: false,
      loading: false,
      error: '',
      observationComment: ''
    }
  },
  beforeMount(){
    if (!this.requestDetail.applicantInfo) {
      this.$router.push('requestList');
      return;
    }
  },
  mounted(){
    this.getRefuseConnectionData();
    this.getObservations();
  },
  methods: {
    getObservations(){
      axios.get("/approvedConnectionObservation/" + this.requestDetail.serviceDetail.requestedService.code)
        .then(responseIdReq => {
            this.observationComment = responseIdReq.data.description
        }) 
    },
    getRefuseConnectionData(){

      axios.get("/refuseConnection/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          this.refuseConnection = true;
          let refuses = response.data;
          refuses.forEach(element => {
            element.titleHeader = "Conexión Rechazada";
            element.state = "Refuse";
            element.documents = [];

            this.requestHistory.push(element);
            axios.get("/refuseConnectionDocument/documents/" + element.id)
            .then(response => {
              if (response.data.length != 0) {
                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                });

                
              }
            });
          });
        }
        this.getApprovedConnectionData();
      })

    },
    getApprovedConnectionData(){

      axios.get("/approvedConnection/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          approved.forEach(element => {
            element.titleHeader = "Conexión Aprobada";
            element.state = "Approved";
            element.documents = [];

            this.requestHistory.push(element);
            axios.get("/approvedConnectionDocument/documents/" + element.id)
            .then(response => {
              if (response.data.length != 0) {
                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                }); 
              }
            });
          });
        }
        this.getUserDesignData();
      })

    },
    getUserDesignData(){

      axios.get("/designData/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          // console.log("response data aprobation designs: ", approved);
          approved.forEach(element => {
            element.titleHeader = "Información de diseño";
            element.state = "Approved";
            element.documents = [];

            this.requestHistory.push(element);
            axios.get("/desingDocument/designData/" + element.id)
            .then(response => {
              if (response.data.length != 0) {
                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                });
              }
            })

          });
        }
        this.getRefuseDesignsData();
      })
    },
    getRefuseDesignsData(){

      axios.get("/refuseDesign/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          let refuseIncrement = 1;
          approved.forEach(element => {
            element.titleHeader = "Diseños Devueltos";
            element.state = "Refuse";
            element.documents = [];
            element.increment = refuseIncrement++;
            
            this.requestHistory.push(element);
            axios.get("/refuseDesignDocument/documents/" + element.id)
            .then(response => {
              if (response.data.length != 0) {
                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                });

                
              }
            });
          });
        }
        this.getLiquidationData();
      })

    },
    getLiquidationData(){

      axios.get("/liquidation/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          approved.forEach(element => {
            element.titleHeader = "Liquidación de diseños";
            element.state = "Other";
            this.requestHistory.push(element);
          });
        }
        this.getAprovationDesignsData();
      })

    },
    getAprovationDesignsData(){

      axios.get("/approvedDesign/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;

          approved.forEach(element => {
            element.titleHeader = "Aprobación diseños";
            element.state = "Approved";
            this.requestHistory.push(element);
          });
        }
        this.getMonitoringActivityData();
      })

    },
    getMonitoringActivityData(){

      axios.get("/monitoringActivitiy/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          approved.forEach(element => {
            element.titleHeader = "Actividad de supervisión de obra";
            element.state = "Other";
            element.documents = [];
            axios.get("/monitoringActivitiyDocument/designData/" + element.id)
            .then(response => {
              if (response.data.length != 0) {

                //console.log("response data design documents: ", response.data)

                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                });

                this.requestHistory.push(element);

              }else{
                this.requestHistory.push(element);
              }
            })
          });
        }
        this.getPutInServiceActivityData();
      })

    },
    getPutInServiceActivityData(){

      axios.get("/startServiceActivity/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          approved.forEach(element => {
            element.titleHeader = "Actividad de puesta en servicio";
            element.state = "Other";
            element.documents = [];
            axios.get("/startServiceActivityDocument/startServiceActivity/" + element.id)
            .then(response => {
              if (response.data.length != 0) {

                //console.log("response data design documents: ", response.data)

                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                });

                this.requestHistory.push(element);

              }else{
                this.requestHistory.push(element);
              }
            })
          });
        }
        this.getCancelConnectionsData();
      })

    }, 
    
    getCancelConnectionsData(){

      axios.get("/cancelConnection/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          let approved = response.data;
          approved.forEach(element => {
            element.titleHeader = "Solicitud Anulada";
            element.state = "Cancel";
            element.documents = [];
            
            this.requestHistory.push(element);
            axios.get("/cancelConnectionDocument/documents/" + element.id)
            .then(response => {
              if (response.data.length != 0) {
                let documents = response.data;
                documents.forEach(el => {
                  element.documents.push(el);
                });
              }
            });
          });
        }
      })

    },     
    tipoCargaRecord(){
      axios.get("/tipocarga/request/" + this.requestDetail.id)
      .then(response => {
        if (response.data.length != 0) {
          this.tipoCargaList = response.data;
        }
      });
      this.tipoCarga = false;
      return;        
    },
    updateRequest(){

      this.loading = true;

      let requestData = {
        "id":this.requestDetail.id,
        "conectionType":this.requestDetail.conectionType,
        "proyectName":this.requestDetail.proyectName,
        "observactions":this.requestDetail.observactions,
        "status":"puesta-en-servicio",
        "applicantInfo":{
          "id":this.requestDetail.applicantInfo.id
        },
        "electricInfrastructure":{
          "id":this.requestDetail.electricInfrastructure.id
        },
        "estateInfo":{
          "id":this.requestDetail.estateInfo.id
        },
        "serviceDetail":{
          "id":this.requestDetail.serviceDetail.id
        },
        "subscriptorInfo":{
          "id":this.requestDetail.subscriptorInfo.id
        },
        "typesUseEconomicActivity":{
          "id":this.requestDetail.typesUseEconomicActivity.id
        },
        "createdDate": this.requestDetail.createdDate,
        "editedDate": new Date()
      }

      axios.post("request/update", requestData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        this.setRequestDetail(result.data);
        this.loading = false;
        this.$router.push('adminRequestDetail');
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    },
    imprimir(){
      window.print();
      return false;
    },
    ...mapMutations({
      setRequestDetail: 'setRequestDetail'
    })
  },
  computed: {
    sortedItems: function() {
      let requestHistorySorted = this.requestHistory.sort((a, b) => new Date(a.createDate) - new Date(b.createDate))
      return requestHistorySorted.reverse();
    },
    ...mapState({
      requestDetail: state => state.requestDetail
    })
  }
}
</script>


<style lang="scss">

@import '@/assets/scss/_variables.scss';

.rotate {
  transform: rotate(90deg);
}

.document-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  .document {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #777;
    border-radius: 4px;
  }
}

.requestHistory {
  border: 1px solid $color-text;
  border-radius: 4px;
  .requestHistory--header {
    background-color: $color-blue;
    color: #fff;
    padding: 10px 15px;
    font-weight: bold;
    border-radius: 4px 4px 0 0;
    margin-bottom: 10px;
    cursor: pointer;
    svg {
      transition: 0.3s;
    }
  }
}
.infoTab {
  border: 1px solid $color-text;
  border-radius: 4px;
  &--body {
    padding: 20px;
  }
  &--green {
    border: 1px solid $color-green;
    .infoTab--header {
      background-color: $color-green !important;
      color: #fff !important;
    }
  }
  &--red {
    border: 1px solid $color-1;
    .infoTab--header {
      background-color: $color-1 !important;
      color: #fff !important;
    }
  }
  &--blue {
    border: 1px solid $color-blue;
    .infoTab--header {
      background-color: $color-blue !important;
      color: #fff !important;
    }
  }
  .infoTab--header {
    display: flex;
    justify-content: space-between;
    background-color: $color-gray;
    color: $color-text;
    padding: 10px 15px;
    font-weight: bold;
    border-radius: 4px 4px 0 0;
    margin-bottom: 10px;
    cursor: pointer;
    svg {
      transition: 0.3s;
    }
  }
}
</style>